import { ReactElement, ReactNode } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { CourseTee } from '../../types/Course';

import CourseTeeView from './CourseTeeView';

interface CourseTeeListViewProps {
  tees: CourseTee[];
  emptyMessage?: string;
  renderAction?: (tee: CourseTee) => ReactNode;
}

export default function CourseTeeListView({ tees, emptyMessage = 'No tees available.', renderAction }: CourseTeeListViewProps): ReactElement {
  if (tees.length === 0) {
    return (
      <Typography variant="bodyMedium" color="text.secondary">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {tees.map((tee) => (
        <CourseTeeView key={tee.itemId} tee={tee} actionSlot={renderAction?.(tee)} />
      ))}
    </Stack>
  );
}
